<template>
  <div id="form-katalog">
    <div style="width: 100%" class="d-flex justify-center">
      <div class="form py-10" style="width: 50%">
        <div class="d-flex justify-center align-center pa-5">
          <v-img
            max-width="100"
            src="../../assets/img/logo-teman-bakat.png"
          ></v-img>
        </div>
        <div v-if="isForm">
          <div class="pa-5">
            <p>
              Cari tahu informasi jurusan kuliah yang tepat untukmu agar tidak
              salah pilih! <br />Isi form dibawah ini untuk mengunduh katalog.
            </p>
          </div>
          <div class="pa-5">
            <v-row>
              <v-col>
                <v-text-field
                  v-model="nama_lenkap"
                  label="Nama Lengkap"
                  required
                  hide-details="auto"
                  :error-messages="errors_key.nama_lengkap"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="usia"
                  label="Usia"
                  required
                  hide-details="auto"
                  :error-messages="errors_key.usia"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="no_telepon"
                  label="No Whatsapp"
                  required
                  hide-details="auto"
                  :error-messages="errors_key.no_telepon"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  required
                  v-model="alasan"
                  label="Mengapa Anda membutuhkan katalog ini?"
                  :error-messages="errors_key.alasan"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-btn
              v-if="!submiting"
              block
              elevation="2"
              class="mt-4"
              style="background-color: #23003a"
              @click="submitForm"
              dark
              >Submit</v-btn
            >
            <v-btn
              v-else
              block
              elevation="2"
              class="mt-4"
              style="background-color: #23003a"
              dark
              >Loading...</v-btn
            >
          </div>
        </div>
        <div v-if="!isForm">
          <div class="pa-5">
            <p>Terima kasih, silakan untuk mengunduh katalog disini</p>
            <div>
              <v-btn
                style="background-color: #23003a"
                block
                dark
                elevation="2"
                @click="
                  download(
                    `https://nos.wjv-1.neo.id/temanbakat/penjurusan/katalog/penjurusan_katalog.pdf`,
                  )
                "
                >Unduh Katalog</v-btn
              >
              <p class="mt-5">Follow kami di Instagram</p>
              <div class="mt-n3">
                <div
                  style="cursor: pointer"
                  class="socmed-item d-flex align-center"
                >
                  <v-icon>mdi mdi-instagram</v-icon
                  ><span class="ml-2"
                    ><a
                      href="https://instagram.com/temanbakat"
                      style="text-decoration: none; color: black"
                      >temanbakat</a
                    ></span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "formKatalog",
  data() {
    return {
      isForm: true,
      nama_lenkap: null,
      alasan: "",
      usia: "",
      no_telepon: "",
      pekerjaan: null,
      pekerjaan_list: ["Siswa", "Mahasiswa", "Guru", "Umum"],
      jurusan: null,
      sekolah: null,
      email: "",
      kota: null,
      emailRules: [
        (v) => !!v || "E-mail harus diisi!",
        (v) => /.+@.+/.test(v) || "Gunakan email yang valid!",
      ],
      items_enum_select: null,
      items_enum_desc: null,
      items_enum: ["Ya", "Tidak"],
      items_enum_select_a: null,
      items_enum_desc_a: null,
      items_enum_a: ["Ya", "Tidak"],
      kelas: null,
      kelas_list: ["-", "VII", "VIII", "IX", "X", "XI", "XII"],
      errors: [],
      errors_message: null,
      errors_key: {
        nama_lengkap: "",
        no_telepon: "",
        usia: "",
        alasan: "",
        pekerjaan: "",
        kelas: "",
        jurusan: "",
        sekolah: "",
        email: "",
        online_test: "",
        online_test_desc: "",
        pertanyaan: "",
        pertanyaan_desc: "",
        kota: "",
      },
      submiting: false,
    };
  },
  mounted() {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((response) => {
        this.$store.dispatch("clickKatalog", response);
      });
  },
  methods: {
    submitForm() {
      this.submiting = true;
      let data = {
        nama_lengkap: this.nama_lenkap,
        no_telepon: this.no_telepon,
        usia: this.usia,
        alasan: this.alasan,
      };
      this.$store
        .dispatch("submitFormKatalog", data)
        .then((res) => {
          if (res.status == "success") {
            this.isForm = false;
          }
          this.submiting = false;
        })
        .catch((err) => {
          let data = err.response.data.data;
          for (const d in data.errors) {
            this.errors_key[d] = data.errors[d][0].split(".")[1];
          }
          this.submiting = false;
        });
    },
    download(uri) {
      let a = document.createElement("a");
      a.target = "_blank";
      a.href = uri;
      a.click();
      this.isDownload = true;
    },
    toKatalog() {
      let vm = this;
      vm.$router.push("/penjurusan/katalog");
    },
  },
};
</script>

<style>
#form-katalog {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/img/penjurusan/asset1.png");
  background-repeat: repeat-y;
}
.form {
  background-color: white;
}
.socmed-item:hover {
  color: yellow !important;
}
@media (max-width: 576px) {
  .form {
    width: 85% !important;
  }
}
</style>
